/**
 * This is an entrypoint for your main javascript file, when you run gulp watch this file and all
 * it's imports will get bundled into a minified js file and saved in the assets/bundle folder
 *
 * Info about importing modules https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
 */

import LazyLoad from 'vanilla-lazyload';

/**
 * This function will lazyload every image with the class .lazy
 * info: https://github.com/verlok/lazyload
 */
var lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazy',
    class_loaded: 'lazy-loaded'
});

$(function () {
    // Make top nav smaller when user vertical scrolls past 100 pixels

    "use strict";

    var $document = $(document),
        $element = $('#top-nav-bar'),
        className = 'scrolled-down',
        className2 = 'add-fx',
        lastScrollTop = 0;

    $(window).scroll(function (event) {
        //hideNavOnScrollDown();
        addFxToNav();
    });

    $element.focusin(function () {
        $element.removeClass(className);
    });

    $(window).on("load", function () {
        addFxToNav();
    });

    $(".open-search").click(function () {
        $("#searchform").addClass("open");
        $("#searchform").fadeIn(300);
        setTimeout(function () {
            document.getElementById("input-search").focus();
        }, 150);
    });
    
    $("#close-searchform").click(function () {
        $("#searchform").removeClass("open");
        $("#searchform").fadeOut(300);
    });

    function addFxToNav() {
        if ($document.scrollTop() >= 150) {
            $element.addClass(className2);
        } else {
            $element.removeClass(className2);
        }
    }

    function hideNavOnScrollDown() {
        var st = $(window).scrollTop();
        if (window.innerWidth >= 1250) {
            if (st > lastScrollTop) {
                // downscroll code
                if ($document.scrollTop() >= 150 && !$element.hasClass(className)) {
                    $element.addClass(className);
                    //console.log("scrolling down: " + st + " " + lastScrollTop);
                }
            } else {
                // upscroll code
                if ($element.hasClass(className)) {
                    $element.removeClass(className);
                    //console.log("scrolling up: " + st + " " + lastScrollTop);
                }
            }
            setTimeout(function () {
                lastScrollTop = st;
            }, 300)
        } else {
            if ($element.hasClass(className)) {
                $element.removeClass(className);
            }
        }
    }
});

$(function () {
    var mobile_nav = $("#mobile-nav"),
        open_nav = $("#open-nav"),
        close_nav = $("#close-nav");

    open_nav.click(function (e) {
        e.preventDefault();
        open_nav.addClass("active");
        mobile_nav.addClass("open");
        $("meta[name='theme-color']").attr('content', "#FDC54B");
    });

    close_nav.click(function (e) {
        e.preventDefault();
        open_nav.removeClass("active");
        mobile_nav.removeClass("open");
        $("meta[name='theme-color']").attr('content', "#FFFFFF");
    });
});